// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { activityLogStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/ActivityLog";
import { css } from "styled-components";

activityLogStyles.changesOldValueText = {
    size: fontConfig.singleLineSmall.size,
    css: css`
        text-decoration: line-through;
        margin-right: 5px;
    `,
};

activityLogStyles.messageBodyText = {
    color: "text",
};

activityLogStyles.changesProductPriceLabelText =
    activityLogStyles.changesProductQtyLabelText =
    activityLogStyles.changesProductSubtotalLabelText =
        {
            transform: "uppercase",
            size: fontConfig.singleLinexSmall.size,
            weight: fontConfig.weight.medium,
            css: css`
                margin-top: 10px;
            `,
        };

activityLogStyles.changesOldProductPriceText =
    activityLogStyles.changesProductOldQtyText =
    activityLogStyles.changesProductOldSubtotalText =
        {
            css: css`
                text-decoration: line-through;
            `,
        };
